import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { DynamicsCopySource } from 'app/model/pipeline/copysource/dynamics.copysource';
import { CopyActivity } from 'app/model/pipeline/copy.activity';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(DynamicsCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*'
    }
})
export class DynamicsCopySourceAdapter extends CopySourceAdapter<DynamicsCopySource, Model.DynamicsSource> {
    protected override async _toResource(copySource: DynamicsCopySource): Promise<Model.DynamicsSource> {
        return this._toTabularResource(copySource, Metamodel.modelFor(DynamicsCopySource).name);
    }

    protected override async _toModel(
        resource: Model.DynamicsSource,
        copyActivity: CopyActivity
    ): Promise<DynamicsCopySource> {
        return this._toTabularModel(resource, copyActivity, DynamicsCopySource.MODEL);
    }
}
